import tableConfig from "./advancedTableColumnsControl.json";

export const getBuildingBaseColumns = () => [
  {
    field: "customerReference",
    headerName: "Name",
    flex: 1,
  },
  {
    field: "borough",
    headerName: "Borough",
    flex: 1,
  },
  {
    field: "ownerString",
    headerName: "Owner",
    flex: 1,
  },
  {
    field: "fullAddress",
    headerName: "Address",
    flex: 1,
  },
  {
    field: "BIN",
    headerName: "BIN",
    flex: 1,
  },
];

export const getBuildingDateUpdatedColumn = () => ({
  field: "dateUpdated",
  headerName: "Last Updated",
  renderCell: ({ row }) => {
    if (!row.dateUpdated) return "";
    const d = typeof row.dateUpdated === "number"
      ? new Date(row.dateUpdated)
      : row.dateUpdated.toDate();
    return d.toISOString().split("T")[0];
  },
});

export const getBuildingColumnsWithHighlighting = () => [
  {
    field: "customerReference_lc",
    headerName: "Name",
    renderCell: ({ row }) => (
      <div
        dangerouslySetInnerHTML={{
          __html: row.displayCustomerReference || row.customerReference,
        }}
      />
    ),
  },
  {
    field: "borough",
    headerName: "Borough",
    renderCell: ({ row }) => (
      <div
        dangerouslySetInnerHTML={{
          __html: row.displayBorough || row.borough,
        }}
      />
    ),
  },
  {
    field: "ownerString_lc",
    headerName: "Owner",
    renderCell: ({ row }) => (
      <div
        dangerouslySetInnerHTML={{
          __html: row.displayOwnerString || row.ownerString,
        }}
      />
    ),
  },
  {
    field: "fullAddress_lc",
    headerName: "Address",
    renderCell: ({ row }) => (
      <div
        dangerouslySetInnerHTML={{
          __html: row.displayFullAddress || row.fullAddress,
        }}
      />
    ),
  },
  {
    field: "BIN",
    headerName: "BIN",
    renderCell: ({ row }) => (
      <div
        dangerouslySetInnerHTML={{
          __html: row.displayBIN || row.BIN,
        }}
      />
    ),
  },
];